import { render, staticRenderFns } from "./Voted.vue?vue&type=template&id=7b64f308&scoped=true&"
import script from "./Voted.vue?vue&type=script&lang=js&"
export * from "./Voted.vue?vue&type=script&lang=js&"
import style0 from "./Voted.vue?vue&type=style&index=0&id=7b64f308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64f308",
  null
  
)

export default component.exports